const form = {
    init() {
        $('.gform_wrapper form').find('input:not([type="checkbox"]), select, textarea').on('change', function() {
            // Check if the field has a value
            if ($(this).val()) {
                // Add 'validated' class if the field is not empty
                $(this).addClass('validated');
            } else {
                // Optionally, remove the class if the field is emptied
                $(this).removeClass('validated');
            }
        });
    }
}

export {form}